/* eslint class-methods-use-this: 0, no-param-reassign: 0 */
import CollectionModule from 'client/store/modules/CollectionModule';
import UserApi from 'client/api/v2/UserApi';

export class UserCollectionClass extends CollectionModule {
  extractModule() {
    const module = super.extractModule();
    module.actions.createNewAdministrator = (...params) => this
      .createNewAdministrator(...params);
    module.actions.resendEmail = (...params) => this.resendEmail(...params);
    module.actions.resetTOTP = (...params) => this.resetTOTP(...params);
    module.actions.updateAdministrator = (...params) => this
      .updateAdministrator(...params);
    module.getters.isItemSelectable = (...params) => this
      .isItemSelectable(...params);

    return module;
  }

  // --------------------------------------------------------------------------
  // State
  // --------------------------------------------------------------------------

  // --------------------------------------------------------------------------
  // Actions
  // --------------------------------------------------------------------------

  /**
   * Creates a new administrator
   * @param {Object} user - User Object
   */
  createNewAdministrator({ dispatch }, user) {
    return this.Api.create(user).then(() => {
      dispatch('refreshCollection', { user });
    });
  }

  /**
   * Resends an email to an administrator
   * @param {String} id - Administrator ID
   */
  resendEmail(context, id) {
    return this.Api.resendEmail(id);
  }

  /**
   * Resets an administrator's TOTP MFA
   * @param {String} id - Administrator ID
   */
  resetTOTP(context, id) {
    return this.Api.resetTOTP(id);
  }

  /**
   * Edits an existing administrator
   * @param {Object} item - Edited User Object
   */
  updateAdministrator({ dispatch }, item) {
    /**
     * Adding in the check on firstname and lastname values to restrict
     * us from sending firstname:null, lastname:null in the event they are
     * undefined for the admin being updated.
     */
    if (!item.firstname) {
      item.firstname = '';
    }
    if (!item.lastname) {
      item.lastname = '';
    }

    const {
      email,
      enableMultiFactor,
      firstname,
      id,
      lastname,
      roleName,
    } = { ...item };

    return dispatch('updateItem', {
      id,
      attributes: {
        email,
        enableMultiFactor,
        firstname,
        id,
        lastname,
        roleName,
      },
    })
      .then(() => {
        dispatch('refreshCollection', item);
      });
  }

  // --------------------------------------------------------------------------
  // Getters
  // --------------------------------------------------------------------------

  /**
   * This overrides the inherited getter. Provider users should not be selectable.
   */
  isItemSelectable() {
    return item => !item.provider;
  }
}

export default new UserCollectionClass(UserApi, '_id', 'email').extractModule();
